import React from "react";
import ExlyImage from "features/Common/modules/ExlyImage/ExlyImage";
import { useCreatorTestimonial } from "./useCreatorTestimonial";
import { StarIcon } from "./StarIcon";
import { CREATOR_TESTIMONIAL_PROPS } from "./CreatorTestimonial.types";

export const CreatorTestimonial = ({
  id,
  testimonial,
  containerClassName,
  cardClassName,
}) => {
  const { badge, authorTitle, roleSubtitle, rating, stars, quote, photoUrl } =
    useCreatorTestimonial(testimonial);

  return (
    <section id={id} className={`${containerClassName}`}>
      <div
        style={{
          borderRadius: "28px",
        }}
        className={`tw-max-w-5xl tw-mx-auto tw-bg-[#FBFBFE] tw-border tw-border-solid tw-border-[#E8E6F5] tw-p-8 tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-8 md:tw-gap-10 tw-items-center ${cardClassName}`}
      >
        {/* Left: Author Profile Card */}
        <div className="md:tw-col-span-5 tw-flex tw-items-center tw-gap-4">
          {/* Avatar or Photo Placeholder */}
          {photoUrl ? (
            <div className="tw-w-20 tw-h-20 sm:tw-w-24 sm:tw-h-24 tw-rounded-2xl tw-overflow-hidden tw-flex-shrink-0 tw-border-2 tw-border-solid tw-border-[#1E1B4B]">
              <ExlyImage
                src={photoUrl}
                alt={authorTitle}
                className="tw-w-full tw-h-full tw-object-cover"
              />
            </div>
          ) : null}

          {/* Author Details */}
          <div className="tw-min-w-0">
            {badge && (
              <div className="tw-text-[11px] tw-font-bold tw-tracking-wider tw-text-indigo-900 tw-uppercase tw-mb-1">
                {badge}
              </div>
            )}
            <div className="tw-text-base tw-font-bold tw-text-slate-900 tw-leading-snug">
              {authorTitle}
            </div>
            {roleSubtitle && (
              <div className="tw-text-xs sm:tw-text-sm tw-text-slate-500 tw-leading-snug tw-mt-1">
                {roleSubtitle}
              </div>
            )}
            <div className="tw-flex tw-items-center tw-gap-1.5 tw-mt-2">
              <div className="tw-flex tw-items-center tw-gap-0.5">
                {stars.map((star) => (
                  <StarIcon key={star.id} isFilled={star.isFilled} />
                ))}
              </div>
              <span className="tw-text-xs tw-font-bold tw-text-slate-700">
                {rating}
              </span>
            </div>
          </div>
        </div>

        {/* Right: Quote Content */}
        <div className="md:tw-col-span-7">
          {/* Quote Marks Icon */}
          <div className="tw-text-[#1E1B4B] tw-text-3xl sm:tw-text-4xl tw-font-black tw-leading-none">
            “
          </div>
          <p className="tw-text-base sm:tw-text-lg tw-italic tw-text-slate-800 tw-leading-relaxed tw-m-0">
            {quote}
          </p>
        </div>
      </div>
    </section>
  );
};

CreatorTestimonial.propTypes = CREATOR_TESTIMONIAL_PROPS;

CreatorTestimonial.defaultProps = {
  id: null,
  testimonial: {},
  containerClassName: "",
  cardClassName: "",
};
